import store from '@/store.js'
import Vue from 'vue'
import permissionMap from '@/util/ACL/permissionMap.js'

export default function(role) {
  // Receive role name as a string parameter
  let client = store.state.client;
  let hasRole = false;

  if (client && role) {
    // Loop through all user roles
    if (client.user_roles && client.user_roles.length) {
      Vue._.forEach(client.user_roles, function(userRole) {
        if (userRole.name === role) {
          hasRole = true;
          return true;
        }
      })
    }
  }

  // Return Boolean if user has given role
  return hasRole;
}
